import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
    selector: 'app-formly-wrapper-fieldset',
    template: `
    <fieldset class="border border-gray-300 rounded px-4 my-4">
      <legend>{{ props.label }}</legend>
      <div class="px-2 mt-2">
        <ng-container #fieldComponent></ng-container>
      </div>
    </fieldset>
  `,
    standalone: true
})
export class FormlyWrapperFieldsetComponent extends FieldWrapper {}
